import serverCalculatorForm from './metaData/serverCalculatorDetail'

import { CAL_SERVER_ORDER_MNG } from '@/api/apiModules'
import { deleteOrder } from '@/api/calculator'
export default {
  calOrderCreate({ commit }, params) {
    const props = {}
    this.dispatch('OpenFullDialog', {
      metaData: serverCalculatorForm,
      props
    })
  },
  calOrderDelete({ commit }, params) {
    var data = {
      idArr: params.rowIds[0]
    }
    deleteOrder(data).then(res => {})
  },
  calOrderEdit({ commit }, params) {
    const props = {
      params: {
        id: params.rowIds[0]
      }
    }
    //const editForm = extend(true, {}, serverCalculatorForm)
    this.dispatch('OpenFullDialog', { metaData: serverCalculatorForm, props })
  },
  segmentSceneExport({ commit }, params) {
    const url = `wsp/${CAL_SERVER_ORDER_MNG}/export?id=${params.rowIds[0]}` // 构造下载链接
    // 使用 window.open 下载文件
    window.open(url, '_blank')
  }
}
